export class Spinner {
    private static singleton: Spinner;
    private spinnerClass = '#loadingSpinner';
    counting: number;

    private constructor() {
        this.counting = 0;
    }

    public static getInstance(): Spinner {
        if (Spinner.singleton == null) {
            Spinner.singleton = new Spinner();
        }
        return Spinner.singleton;
    }

    startSpinner() {
        this.counting++;
        this.checkSpinner();
    }

    stopSpinner() {
        if (this.counting > 0) {
            this.counting--;
        }
        this.checkSpinner();
    }

    resetSpinner() {
        while (this.counting > 0) {
            this.stopSpinner();
        }
    }

    private checkSpinner() {
        const spinner: HTMLDivElement = document.querySelector(this.spinnerClass);
        if (this.counting > 0) {
            spinner.classList.add('show');
            document.body.style.overflow = 'hidden';
        } else {
            spinner.classList.remove('show');
            document.body.style.overflow = 'unset';
        }
    }
}
